import { defineComponent } from 'vue';
import { numWithDots } from '~/lib/utils';
import { tradeAreaClient } from '../lib/client';
import Spinner from './Spinner.vue';
export default defineComponent({
    name: 'Summary',
    components: { Spinner },
    props: {
        project: {
            type: Number,
            default: 0,
        },
        open: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['select', 'close'],
    data() {
        return {
            projects: [],
            selectedProjectId: 0,
            completeProject: null,
            loadingProjects: false,
            loadingComplete: false,
        };
    },
    computed: {
        selectedProject() {
            return this.projects.find((p) => p.id === this.selectedProjectId) || null;
        },
    },
    watch: {
        async selectedProjectId() {
            this.$emit('select', this.selectedProject);
            this.completeProject = null;
            if (this.selectedProjectId === 0)
                return;
            this.loadingComplete = true;
            await this.fetchCompleteProject();
            this.loadingComplete = false;
        },
        async open() {
            if (this.open) {
                this.selectedProjectId = this.project;
                this.loadingProjects = true;
                const promeses = [this.fetchProjects()];
                if (this.project)
                    promeses.push(this.fetchCompleteProject());
                await Promise.all(promeses);
                this.loadingProjects = false;
            }
        },
    },
    methods: {
        formatPrice(x) {
            return numWithDots(x);
        },
        async fetchProjects() {
            this.projects = await tradeAreaClient.getProjects({ limit: 0 });
        },
        async fetchCompleteProject() {
            this.completeProject = await tradeAreaClient.getProject(this.selectedProjectId);
        },
        async editProject(query) {
            this.$router.push({
                name: 'editProject',
                query
            });
        },
    },
});
